import { makeStyles } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../Language/LanguageProvider';

const useStyles = makeStyles(theme => ({
  roboIcon: {
    position: 'fixed',
    bottom: '1.2em',
    right: '0.9em',
    fontSize: '3rem',
    zIndex: 9999,
  },
  speechGlobe: {
    fontSize: '1rem',
    textAlign: 'center',
    position: 'fixed',
    right: '3.5em',
    bottom: '5em',
    height: '11em',
    width: '11em',
    backgroundColor: '#444',
    padding: '0.2em 0.5em',
    clipPath: `polygon(
      0% 0%,
      100% 0%,
      100% 75%,
      75% 75%,
      75% 100%,
      50% 75%,
      0% 75%
    )`,
  },
}));

const RoboIcon = ({ handleOpenChat, color, isChatOpen }) => {
  const classes = useStyles();
  const [showSpeech, setShowSpeech] = useState(false);
  const { userLanguage } = useContext(LanguageContext);
  const handleMouseEnter = () => {
    setShowSpeech(true);
  };

  const handleMouseLeave = () => {
    setShowSpeech(false);
  };

  if (userLanguage === 'en') {
    return null;
  }

  return (
    <span
      className={classes.roboIcon}
      style={{
        color: color,
      }}
      onClick={() => handleOpenChat(prev => !prev)}
    >
      {!isChatOpen && showSpeech && (
        <div className={classes.speechGlobe}>
          Podes hacer click sobre mi para conversar, y luego nuevamente para
          cerrar el chat.
        </div>
      )}
      <i
        className="fas fa-user-astronaut"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      ></i>
    </span>
  );
};

export default RoboIcon;
